<script lang="ts">
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import { isKeg, soldInCases, soldInUnits } from "@shared/svelte/ProductHelpers.js";
  import type { Discount } from "@shared/types/Deals";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";

  export let discount: Discount;
  export let getUnitPrice: (product: Discount) => number;
  export let inventoryId: number;

  $: inventoryItemSoldBy = $InventoryItemStore?.inventoryItems[inventoryId]?.sold_by;
</script>

<div>
  {#if ((soldInUnits(discount, discount, inventoryItemSoldBy) && !soldInCases(discount, discount, inventoryItemSoldBy)) || isKeg(discount) || discount.unit_type == "units") && discount.unit_price}
    <FormatMoney input={discount.unit_price} />/{discount.container_type}
  {:else if soldInCases(discount, discount, inventoryItemSoldBy) && discount.case_price}
    <FormatMoney input={discount.case_price} />/case
  {/if}

  {#if soldInCases(discount, discount, inventoryItemSoldBy) && discount.unit_type != "units"}
    {#if discount.unit_price}
      <br />
      <span class="fizz-text-small fizz-text-subdued">
        <FormatMoney input={getUnitPrice(discount)} />/{discount.container_type}
      </span>
    {:else if discount.case_price && discount.container_case_size}
      <br />
      <span class="fizz-text-small fizz-text-subdued">
        <FormatMoney
          input={discount.case_price / discount.container_case_size}
        />/{discount.container_type}
      </span>
    {/if}
  {/if}
</div>
